// EPP 2.0 — Ficha de producto (rehecho en limpio 2026-08-25).
// Lee sus datos del bloque JSON #epp2PdpData que imprime la sección.
// Contratos que respeta: fetch a /cart/add.js con sections cart-drawer+cart-icon-bubble,
// mini como 2º line item con properties Aroma/Tamaño/_ref, evento global epp:variant.
(function () {
  var datos = document.getElementById('epp2PdpData');
  var root = document.getElementById('epp2Pdp');
  if (!datos || !root) return;
  var D;
  try { D = JSON.parse(datos.textContent); } catch (e) { return; }

  var form = root.querySelector('.epp-pdp-form');
  var variantInput = root.querySelector('[data-variant-input]');
  var cta = root.querySelector('[data-cta]');
  var cards = root.querySelectorAll('.size-card');
  var qty = document.getElementById('epp2Qty');
  var stickyPrice = root.querySelector('[data-sticky-price]');
  var stickySize = root.querySelector('[data-sticky-size]');
  var sticky = document.getElementById('epp2Sticky');
  var selMini = null;

  function money(cents) {
    var n = cents / 100;
    return '$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2).replace('.', ','));
  }
  function activa() { return root.querySelector('.size-card.on') || cards[0]; }
  function baseCents() {
    var a = activa();
    if (a) return parseInt(a.getAttribute('data-variant-price'), 10) || 0;
    return parseInt(D.precio, 10) || 0; // productos de una sola variante: sin tarjetas
  }
  function pinta() {
    var a = activa();
    var q = qty ? (parseInt(qty.value, 10) || 1) : 1;
    var total = (baseCents() * q) + (selMini ? selMini.cents : 0);
    // el span del precio se re-consulta en vivo: un mensaje de error pudo recrearlo
    var cp = cta && cta.querySelector('[data-cta-price]');
    if (cp) cp.textContent = money(total);
    if (stickyPrice) stickyPrice.textContent = money(total);
    // precio grande bajo el titulo: valor del perfume (tamano elegido + mini), sin multiplicar cantidad
    var pv = root.querySelector('[data-precio-vivo]');
    if (pv) pv.textContent = money(baseCents() + (selMini ? selMini.cents : 0));
    if (stickySize) stickySize.textContent = (q > 1 ? q + ' × ' : '') + (a ? a.getAttribute('data-variant-title') : (D.talla || ''));
  }

  // --- selector de tamaños ---
  cards.forEach(function (c) {
    c.addEventListener('click', function () {
      if (c.hasAttribute('disabled')) return;
      cards.forEach(function (x) { x.classList.remove('on', 'active'); });
      c.classList.add('on', 'active');
      if (variantInput) variantInput.value = c.getAttribute('data-variant-id');
      // rehabilitar o agotar el CTA segun la variante elegida (fix del panel)
      if (cta) {
        var disponible = c.getAttribute('data-variant-available') === 'true';
        var lbl = cta.querySelector('[data-cta-label]');
        var ago = cta.querySelector('[data-cta-agotado]');
        if (disponible) { cta.removeAttribute('disabled'); if (lbl) lbl.hidden = false; if (ago) ago.hidden = true; }
        else { cta.setAttribute('disabled', ''); if (lbl) lbl.hidden = true; if (ago) ago.hidden = false; }
      }
      pinta();
      // contrato: la sticky vieja y el modal de envío escuchan este evento
      document.dispatchEvent(new CustomEvent('epp:variant', { detail: {
        id: c.getAttribute('data-variant-id'),
        price: money(parseInt(c.getAttribute('data-variant-price'), 10) || 0),
        title: c.getAttribute('data-variant-title'),
        available: c.getAttribute('data-variant-available') === 'true'
      } }));
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', c.getAttribute('data-variant-id'));
        window.history.replaceState({}, '', u.toString());
      } catch (e) {}
    });
  });

  // --- add-on minis (segundo clic deselecciona) ---
  root.querySelectorAll('.addon-opt').forEach(function (opt) {
    opt.addEventListener('click', function () {
      var estaba = opt.classList.contains('on');
      root.querySelectorAll('.addon-opt').forEach(function (o) { o.classList.remove('on'); });
      if (estaba) {
        selMini = null;
      } else {
        opt.classList.add('on');
        selMini = {
          vid: opt.getAttribute('data-mini-vid'),
          label: opt.getAttribute('data-mini-label'),
          cents: parseInt(opt.getAttribute('data-mini-cents'), 10) || 0
        };
      }
      pinta();
    });
  });

  if (qty) qty.addEventListener('change', pinta);

  // --- boton "Descripcion completa": expande el desplegable de abajo y navega hasta el ---
  var irDesc = root.querySelector('[data-ir-desc]');
  if (irDesc) irDesc.addEventListener('click', function () {
    var d = document.getElementById('epp2Desc');
    var mas = document.getElementById('epp2DescMas');
    if (d && mas && d.classList.contains('epp2-pf__desc--corta')) mas.click();
    if (d) setTimeout(function () { d.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 60);
  });

  // --- galería con miniaturas ---
  var thumbs = root.querySelectorAll('.epp2-g__th');
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      thumbs.forEach(function (x) { x.classList.remove('on'); });
      root.querySelectorAll('.epp2-g__vista').forEach(function (v) { v.classList.remove('on'); });
      t.classList.add('on');
      var vista = root.querySelector('.epp2-g__vista[data-v="' + t.getAttribute('data-v') + '"]');
      if (vista) vista.classList.add('on');
    });
  });

  // Precarga de las demas fotos en cuanto el navegador esta libre: al tocar una miniatura la imagen ya esta
  // en cache y el cambio es inmediato. Va DESPUES de la carga inicial para no competir con la primera foto.
  function precargarGaleria() {
    root.querySelectorAll('.epp2-g__vista img').forEach(function (im) {
      if (im.complete && im.naturalWidth > 0) return;
      im.loading = 'eager';
      var url = im.currentSrc || im.src;
      if (url) { var g = new Image(); g.decoding = 'async'; g.src = url; }
    });
  }
  function lanzarPrecarga() {
    if ('requestIdleCallback' in window) window.requestIdleCallback(precargarGaleria, { timeout: 2500 });
    else setTimeout(precargarGaleria, 1200);
  }
  if (document.readyState === 'complete') lanzarPrecarga();
  else window.addEventListener('load', lanzarPrecarga, { once: true });

  // --- add to cart: mismo contrato que la PDP vieja ---
  function eppItems() {
    var q = qty ? (parseInt(qty.value, 10) || 1) : 1;
    var items = [{ id: variantInput.value, quantity: q }];
    if (selMini) {
      items.push({ id: selMini.vid, quantity: 1, properties: { 'Aroma': D.aroma, 'Tamaño': selMini.label, '_ref': D.handle } });
    }
    return items;
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!cta || cta.hasAttribute('disabled') || cta.classList.contains('loading')) return;
      cta.classList.add('loading');
      fetch(D.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: eppItems(), sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
      }).then(function (r) { return r.json(); }).then(function (data) {
        cta.classList.remove('loading');
        if (data && data.status && !data.sections) {
          // Shopify rechazo el pedido (p.ej. sin stock): avisar sin romper nada
          var lblErr = cta.querySelector('[data-cta-label]');
          if (lblErr) {
            var previo = lblErr.innerHTML;
            lblErr.textContent = 'Sin stock suficiente';
            setTimeout(function () { lblErr.innerHTML = previo; pinta(); }, 2200);
          }
          return;
        }
        if (data && data.sections) {
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble && data.sections['cart-icon-bubble']) {
            var t1 = document.createElement('div');
            t1.innerHTML = data.sections['cart-icon-bubble'];
            var nuevo = t1.querySelector('#cart-icon-bubble') || t1.firstElementChild;
            if (nuevo) bubble.innerHTML = nuevo.innerHTML;
          }
          var drawer = document.querySelector('cart-drawer');
          if (drawer && data.sections['cart-drawer']) {
            var t2 = document.createElement('div');
            t2.innerHTML = data.sections['cart-drawer'];
            var nd = t2.querySelector('cart-drawer');
            if (nd) drawer.innerHTML = nd.innerHTML;
            drawer.classList.remove('is-empty');
            if (typeof drawer.open === 'function') drawer.open();
            else drawer.classList.add('active', 'animate');
          }
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'epp2-pdp', cartData: data });
        }
        document.dispatchEvent(new CustomEvent('epp:added', { detail: data }));
      }).catch(function () {
        cta.classList.remove('loading');
        window.location.href = D.cartUrl;
      });
    });
  }

  // --- barra fija móvil: dispara el CTA real (así el mini viaja igual) ---
  var sBtn = document.getElementById('epp2StickyAdd');
  if (sBtn) sBtn.addEventListener('click', function () {
    if (cta && !cta.hasAttribute('disabled')) cta.click();
  });
  if (sticky) {
    window.addEventListener('scroll', function () {
      if (window.innerWidth >= 900) return;
      sticky.classList.toggle('on', window.scrollY > 520);
    }, { passive: true });
  }

  // --- perfil olfativo desde los metacampos verificados (si existen) ---
  (function () {
    var caja = document.getElementById('epp2Perfil');
    var body = document.getElementById('epp2PerfilBody');
    if (!caja || !body) return;
    function leer(v) {
      if (v === null || v === undefined || v === '') return null;
      if (typeof v === 'string') { try { return JSON.parse(v); } catch (e) { return v; } }
      return v;
    }
    var pir = leer(D.piramide);
    var notas = leer(D.notas);
    var dur = leer(D.duracion);
    var html = '';
    if (Array.isArray(notas) && notas.length) {
      html += '<div class="epp2-acc__chips">';
      notas.forEach(function (n) { html += '<span class="epp2-acc__chip">' + n + '</span>'; });
      html += '</div>';
    }
    if (pir && (pir.salida || pir.corazon || pir.fondo)) {
      html += '<ul class="epp2-acc__pir">';
      if (pir.salida) html += '<li><b>Salida</b> ' + [].concat(pir.salida).join(', ') + '</li>';
      if (pir.corazon) html += '<li><b>Corazón</b> ' + [].concat(pir.corazon).join(', ') + '</li>';
      if (pir.fondo) html += '<li><b>Fondo</b> ' + [].concat(pir.fondo).join(', ') + '</li>';
      html += '</ul>';
    }
    if (dur && dur.piel_min && dur.piel_max) {
      html += '<p class="epp2-acc__dato">Le dura de ' + dur.piel_min + ' a ' + dur.piel_max + ' horas en piel</p>';
    }
    if (html) { body.innerHTML = html; caja.hidden = false; }
  })();

  // --- rieles con la MISMA tarjeta del catalogo (Section Rendering API) ---
  // El servidor renderiza snippets/epp2-card.liquid (estrellas Judge.me + boton),
  // el JS solo inyecta el HTML. Nada de tarjetas armadas a mano.
  function inyectaRiel(url, cont, row, orden) {
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fila = doc.querySelector('[data-riel]');
      if (!fila || !fila.children.length) return;
      row.innerHTML = fila.innerHTML;
      if (orden && orden.length) {
        // el buscador devuelve los ids sin orden util: restauramos el de recencia por handle
        var mapa = {};
        Array.prototype.forEach.call(row.children, function (c) {
          var h = (c.getAttribute('href') || '').split('?')[0].split('/').filter(Boolean).pop();
          mapa[h] = c;
        });
        orden.slice().reverse().forEach(function (h) {
          if (mapa[h]) row.insertBefore(mapa[h], row.firstChild);
        });
      }
      cont.hidden = false;
      flechasRiel(cont, row);
    }).catch(function () {});
  }

  // flechas del riel (PC): scrollBy suave de un 80% del ancho visible; se encienden solo si el riel desborda
  function flechasRiel(cont, row) {
    var nav = cont.querySelector('.epp2-rail__nav');
    if (!nav) return;
    var prev = nav.querySelector('[data-rail-prev]');
    var next = nav.querySelector('[data-rail-next]');
    var estado = function () {
      var desborda = row.scrollWidth > row.clientWidth + 1;
      nav.classList.toggle('on', desborda);
      if (!desborda) return;
      if (prev) prev.disabled = row.scrollLeft <= 4;   /* en reposo el snap deja scrollLeft = 2 (padding-left del riel) */
      if (next) next.disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 1;
    };
    var mueve = function (dir) {
      row.scrollBy({ left: dir * Math.round(row.clientWidth * 0.8), behavior: 'smooth' });
    };
    if (prev) prev.addEventListener('click', function () { mueve(-1); });
    if (next) next.addEventListener('click', function () { mueve(1); });
    row.addEventListener('scroll', estado, { passive: true });
    window.addEventListener('resize', estado);
    estado();
    window.addEventListener('load', estado);
  }

  // --- tambien te recomendamos (recomendaciones nativas de Shopify) ---
  (function () {
    var cont = document.getElementById('epp2Recs');
    var row = document.getElementById('epp2RecsRow');
    if (!cont || !row) return;
    inyectaRiel((D.recsUrl || '/recommendations/products') + '?section_id=epp2-riel-recs&product_id=' + D.id + '&limit=8&intent=related', cont, row);
  })();

  // --- visto recientemente: registrar esta visita (en el tema nuevo nadie mas escribe la clave) ---
  (function () {
    try {
      var rv = JSON.parse(window.localStorage.getItem('eppRecentlyViewed') || '[]');
      if (!Array.isArray(rv)) rv = [];
      rv = rv.filter(function (x) { return x && String(x.id) !== String(D.id); });
      // handle y price acompanan por compatibilidad con el lector del tema vivo
      rv.unshift({ id: D.id, handle: D.handle, title: D.titulo || document.title, url: location.pathname, image: D.imagen || '', price: parseInt(D.precio, 10) || null });
      rv = rv.filter(function (x, i) { return rv.findIndex(function (y) { return String(y.id) === String(x.id); }) === i; });
      window.localStorage.setItem('eppRecentlyViewed', JSON.stringify(rv.slice(0, 12)));
    } catch (e) {}
  })();

  // --- visto recientemente: pintar el riel (busqueda por id via Section Rendering API) ---
  (function () {
    var cont = document.getElementById('epp2Visto');
    var row = document.getElementById('epp2VistoRow');
    if (!cont || !row) return;
    var rv = [];
    try { rv = JSON.parse(window.localStorage.getItem('eppRecentlyViewed') || '[]'); } catch (e) { rv = []; }
    if (!Array.isArray(rv)) return;
    var vistos = rv.filter(function (x) { return x && x.id && String(x.id) !== String(D.id); }).slice(0, 8);
    if (!vistos.length) return;
    var ids = vistos.map(function (x) { return 'id:' + x.id; });
    var orden = vistos.map(function (x) { return x.handle || (x.url || '').split('?')[0].split('/').filter(Boolean).pop(); });
    inyectaRiel((D.searchUrl || '/search') + '?section_id=epp2-riel-visto&type=product&q=' + encodeURIComponent(ids.join(' OR ')), cont, row, orden);
  })();

  // --- pulido de la descripción: fuera emojis, primera letra en mayúscula en las listas ---
  (function () {
    var d = document.getElementById('epp2Desc');
    if (!d) return;
    var re = /[\u{1F000}-\u{1FAFF}\u{2600}-\u{27BF}\u{2B00}-\u{2BFF}\u{FE0F}\u{200D}]/gu;
    var w = document.createTreeWalker(d, NodeFilter.SHOW_TEXT);
    var n;
    while ((n = w.nextNode())) {
      var limpio = n.nodeValue.replace(re, '').replace(/ {2,}/g, ' ');
      if (limpio !== n.nodeValue) n.nodeValue = limpio;
    }
    d.querySelectorAll('li').forEach(function (li) {
      var w2 = document.createTreeWalker(li, NodeFilter.SHOW_TEXT);
      var t;
      while ((t = w2.nextNode())) {
        var s = t.nodeValue;
        var m = s.match(/[A-Za-zÁÉÍÓÚÜÑáéíóúüñ]/);
        if (m) {
          var i = s.indexOf(m[0]);
          t.nodeValue = s.slice(0, i) + s.charAt(i).toUpperCase() + s.slice(i + 1);
          break;
        }
      }
    });

    // desplegable: cerrado de inicio con el arranque asomado; si es cortita, ni botón.
    // Con imágenes en la descripción se re-mide en load (defer corre antes de que carguen).
    var mas = document.getElementById('epp2DescMas');
    if (mas) {
      // ojo: el primer span del botón es el ICONO — el rótulo vive en [data-desc-lbl] y el símbolo en .epp2-acc__mas
      var lblMas = mas.querySelector('[data-desc-lbl]');
      var simbolo = mas.querySelector('.epp2-acc__mas');
      var tocado = false;
      mas.addEventListener('click', function () {
        tocado = true;
        var cerrada = d.classList.toggle('epp2-pf__desc--corta');
        if (lblMas) lblMas.textContent = cerrada ? 'Leer la descripción completa' : 'Ver menos';
        if (simbolo) simbolo.textContent = cerrada ? '+' : '−';
        mas.setAttribute('aria-expanded', cerrada ? 'false' : 'true');
        if (cerrada) {
          // al retraer, subir la cámara al inicio de la descripción (bajo el header pegajoso)
          var y = Math.max(0, d.getBoundingClientRect().top + window.pageYOffset - 165);
          if (window.pageYOffset > y) window.scrollTo({ top: y, behavior: 'smooth' });
        }
      });
      var decide = function () {
        if (tocado) return;
        d.classList.add('epp2-pf__desc--corta');
        if (d.scrollHeight > d.clientHeight + 24) {
          mas.hidden = false;
        } else {
          d.classList.remove('epp2-pf__desc--corta');
          mas.hidden = true;
        }
        if (lblMas) lblMas.textContent = 'Leer la descripción completa';
        if (simbolo) simbolo.textContent = '+';
        mas.setAttribute('aria-expanded', 'false');
      };
      decide();
      if (d.querySelector('img')) window.addEventListener('load', decide);
    }
  })();

  pinta();
})();
